import React, { useEffect, useState } from 'react';
import ApiServices from '../../../Utils/ApiServices/ApiServices';
import { getDecryptedAccessToken } from '../../../Utils/LoginUserDetails.js/LoginUserSavedDetails';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, Typography, CircularProgress, Box
} from '@mui/material';

const MembershipGroupsAll = ({ onExerciseClick }) => {
  const accessToken = getDecryptedAccessToken();
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchMembershipGroups = async () => {
    try {
      const response = await ApiServices.get('/apis/default/api/membershipgroups', {
        Authorization: `Bearer ${accessToken}`
      });
      setGroups(response.data || []);
    } catch (error) {
      console.error('Error fetching membership groups:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMembershipGroups();
  }, []);

  return (
    <div>
      <Typography variant="h5" gutterBottom>Membership Groups</Typography>
      {loading ? (
        <CircularProgress />
      ) : (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell><strong>Group ID</strong></TableCell>
                <TableCell><strong>Type</strong></TableCell>
                <TableCell><strong>Name</strong></TableCell>
                <TableCell><strong>Created At</strong></TableCell>
                <TableCell><strong>Members Stats</strong></TableCell>
                <TableCell><strong>Plans</strong></TableCell>
                <TableCell><strong>Members</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {groups.map((group) => (
                <TableRow key={group.group_id} onClick={(e) => e.stopPropagation() || onExerciseClick(group)} hover>
                  <TableCell>{group.group_id}</TableCell>
                  <TableCell>{group.group_type}</TableCell>
                  <TableCell>{group.group_name}</TableCell>
                  <TableCell>{group.created_at}</TableCell>
                  <TableCell>
                    Total: {group.member_stats.total}<br />
                    Approved: {group.member_stats.approved}<br />
                    Pending: {group.member_stats.pending}<br />
                    Removed: {group.member_stats.removed}
                  </TableCell>
                  <TableCell>
                    {group.plans.map((plan, idx) => (
                      <div key={idx}>
                        {plan.plan_tier} {plan.category && `(${plan.category})`}
                      </div>
                    ))}
                  </TableCell>
                  <TableCell>
                    {group.members && group.members.length > 0 ? (
                      group.members.map((member, index) => (
                        <Box key={index} sx={{ mb: 1 }}>
                          <strong>{member.fname} {member.lname}</strong> – {member.role}
                        </Box>
                      ))
                    ) : (
                      <Typography variant="body2" color="textSecondary">No Members</Typography>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </div>
  );
};

export default MembershipGroupsAll;
